
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forrester-total-economic-impact",
      function () {
        return require("private-next-pages/forrester-total-economic-impact/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forrester-total-economic-impact"])
      });
    }
  